import axios from 'axios';

const instance = axios.create({});

export { instance as axios };
